var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"about"},[_c('AppSection',{staticClass:"hero",attrs:{"data":{
      img: { src: _vm.about.hero.img.src },
    }}},[_c('div',{staticClass:"hero__container"},[_c('AppHeadline',{staticClass:"hero__headline",attrs:{"data":{
          content: _vm.about.hero.title,
          type: 2,
        }}}),_c('span',{staticClass:"section__line hero__line"}),_c('div',{staticClass:"hero__text"},[_c('AppParagraph',{staticClass:"text-content",attrs:{"data":{
            content: _vm.about.hero.content[0],
          }}}),_c('AppParagraph',{staticClass:"text-content",staticStyle:{"opacity":"0"},attrs:{"data":{
            content: _vm.about.hero.content[1],
          }}})],1)],1)]),_c('AppSection',{staticClass:"intro",attrs:{"data":{
      img: { src: '/assets/video/about_0.jpg' },
      video: { src: '/assets/video/about_0.m4v' },
    }}},[_c('span',{staticClass:"intro__sphere",style:({
        backgroundImage: ("url('/assets/svg/sphere" + (_vm.isSafari() ? '-safari' : '') + ".svg')"),
      })}),_c('div',{staticClass:"intro__container"},[_c('AppHeadline',{staticClass:"intro__headline",attrs:{"data":{
          content: _vm.about.intro.title,
          type: 2,
        }}}),_c('span',{staticClass:"section__line intro__line"}),_c('AppParagraph',{staticClass:"intro__text",attrs:{"data":{
          content: _vm.about.intro.content,
        }}})],1),_c('div',{staticClass:"intro__container"},[_c('ul',_vm._l((_vm.about.intro.list),function(item,i){return _c('li',{key:("item-" + i),staticClass:"list__items"},[_c('AppHeadline',{staticClass:"item__headline",attrs:{"data":{
              content: item.firstLine,
              type: 3,
            }}}),_c('AppParagraph',{attrs:{"data":{
              content: item.secondLine,
            }}})],1)}),0)])]),_c('NewsPreview',{attrs:{"title":"OUR THINKING","haveButton":true}}),_c('AppFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }